import React, { useId } from 'react';

export function Input({
  label,
  id = undefined,
  className = '',
  inputClassName = '',
  multiline = false,
  rows = 3,
  error = false,
  errorMessage = '',
  helperText = '',
  ...rest
}) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <div
      className={`input-field ${className} ${error ? 'input-field--error' : ''}`.trim()}
    >
      {label && (
        <label className="input-field__label" htmlFor={inputId}>
          {label}
        </label>
      )}
      {multiline ? (
        <textarea
          id={inputId}
          className={`input-field__control ${inputClassName}`.trim()}
          rows={rows}
          aria-invalid={error}
          {...rest}
        />
      ) : (
        <input
          id={inputId}
          className={`input-field__control ${inputClassName}`.trim()}
          aria-invalid={error}
          {...rest}
        />
      )}
      {error && errorMessage && (
        <div className="input-field__error">{errorMessage}</div>
      )}
      {!error && helperText && (
        <div className="input-field__helper">{helperText}</div>
      )}
    </div>
  );
}
